import Vue from 'vue';
import VueImagePreview from './image-preview';

let instance;

const defaultConfig = {
  images: [],
  loop: true,
  swipeDuration: 500,
  value: true,
  minZoom: 1 / 3,
  maxZoom: 3,
  className: '',
  onClose: null,
  onChange: null,
  lazyLoad: false,
  showIndex: true,
  asyncClose: false,
  startPosition: 0,
  showIndicators: false,
  closeOnPopstate: false,
  showDeleteActions: false,
  onClickDeleteActions: null
};

const initInstance = () => {
  instance = new (Vue.extend(VueImagePreview))({
    el: document.createElement('div')
  });
  document.body.appendChild(instance.$el);
};

const ImagePreview = (images, startPosition = 0) => {
  if (!instance) {
    initInstance();
  }
  const options = Array.isArray(images) ? { images, startPosition } : images;

  instance.value = true;
  Object.assign(instance, defaultConfig, options)
  instance.$on('input', show => {
    instance.value = show;
  });

  return instance;
};

ImagePreview.install = () => {
  Vue.use(VueImagePreview);
};

export default ImagePreview;



// WEBPACK FOOTER //
// ./src/plugins/jscom/omui/components/image-preview/index.js